import SingleStatBox from './shared/SingleStatBox'
import NewDataTable from 'Shared/components/NewDataTable/NewDataTable'
import Chart from './shared/Chart'
import './screens/ScreensCommon.scoped.scss'
import { transformChartData, chartColors } from 'Analytics/utils/transformChartData';
import { set } from 'lodash';

const formatDateCell = (date) =>
  (new Date(date)).toLocaleString('default', { month: 'long', day: 'numeric' })

export default function SimpleAnalyticsView({ chartData }) {
  const { title, data, series } = chartData
  const [enabledSeries, setEnabledSeries] = useState(series.map(s => s.key));

  function setSeriesEnabled(key, enabled) {
    setEnabledSeries(prev => enabledSeries.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
  }

  const columns = [
    { key: 'time', label: 'Date', sortable: true, render: formatDateCell },
    ...series.map(({ key, label }) => ({ key, label, sortable: true })),
  ];

  const lines = series.map(({ key, label }, index) => ({
    label,
    key,
    color: chartColors[index % chartColors.length],
    enabled: enabledSeries.includes(key)
  }))

  const singleStats = series.map(({ key, label }, index) => ({
    label,
    value: data.reduce((sum, row) => sum + (row[key] || 0), 0)
  }));

  const dataWithNames = data.map(row => {
    return ({
      ...row,
      name: new Date(row.time).toLocaleString('default', { month: 'short', day: 'numeric' })
    });
  })

  return <>
    <div className="headline-stats">
      {singleStats.map((stat, index) => (
        <SingleStatBox key={index} label={stat.label} value={stat.value} change={0.0} />
      ))}
    </div>

    <Chart
      title={title}
      data={dataWithNames}
      lines={lines}
      setSeriesEnabled={setSeriesEnabled}
      xLabel="Day of the week"
      yLabel="Number of texts" />

    <NewDataTable columns={columns} data={data} />

  </>
}
